import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface CusAuthState {
  cusJwtToken: string | null;
  setCusJwtToken: (token: string | null) => void;
}

export const useCusAuth = create<CusAuthState>()(
  persist(
    (set) => ({
      cusJwtToken: null,
      setCusJwtToken: (token) => set({ cusJwtToken: token }),
    }),
    {
      name: "cus-auth-storage",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
